import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "locations";

export const getProvincesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/provinces`);
  return data.result;
};

export const getCitiesAsync = async (provinceId) => {
  const { data } = await http.get(`${apiEndpoint}/cities/${provinceId}`);
  return data.result;
};

const locationService = {
  getProvincesAsync,
  getCitiesAsync,
};

export default locationService;
